import { computed, ref } from "vue"
import { UseRootStore } from "@/model/RootStore"
import { Page } from "@/graphql"

export const DefaultPages = [
	Page.Activity,
	Page.Exploration,
	Page.Hunting,
	Page.Opportunities,
	Page.Transactions,
	Page.Buyers,
]

export function isDefaultPage(value: string | null | undefined): value is Page {
	return DefaultPages.includes(value as Page)
}

export function useDefaultPagePreference() {
	const store = UseRootStore()
	const defaultPageDraft = ref(Page.Exploration)
	const savedDefaultPage = ref(Page.Exploration)
	const hasDefaultPagePendingChanges = computed(() => defaultPageDraft.value !== savedDefaultPage.value)

	const syncDefaultPageFromProfile = () => {
		const profileDefaultPage = store.CurrentUserBasicDetails?.defaultPage
		const defaultPage = isDefaultPage(profileDefaultPage) ? profileDefaultPage : Page.Exploration
		defaultPageDraft.value = defaultPage
		savedDefaultPage.value = defaultPage
	}

	const saveDefaultPagePreference = async () => {
		if (!hasDefaultPagePendingChanges.value) {
			return
		}

		await store.saveDefaultPage(defaultPageDraft.value)
		savedDefaultPage.value = defaultPageDraft.value
	}

	const resetDefaultPagePreference = () => {
		defaultPageDraft.value = savedDefaultPage.value
	}

	return {
		defaultPageDraft,
		hasDefaultPagePendingChanges,
		syncDefaultPageFromProfile,
		saveDefaultPagePreference,
		resetDefaultPagePreference,
	}
}
